import { atom } from "jotai";

/**
 * 앱이 주입한 푸시 문구 맵 { [locKey]: "{{0}}님이 연결을 요청했어요." }.
 * 웹뷰 단독(브라우저 직접 접근)으로 열리면 비어 있고, 그때는 서버가 내려준 content 로 폴백한다.
 */
export const pushLocStringsAtom = atom<Record<string, string>>({});
